import React, { useState } from "react";
import "./ego.css";

const GENERATION_OPTIONS = [
  { id: "", tr: "Belirtmek istemiyorum", en: "Prefer not to say" },
  { id: "before_1965", tr: "1964 ve öncesi", en: "1964 and earlier" },
  { id: "gen_x_1965_1980", tr: "1965–1980", en: "1965–1980" },
  { id: "gen_y_1981_1996", tr: "1981–1996", en: "1981–1996" },
  { id: "gen_z_1997_2012", tr: "1997–2012", en: "1997–2012" }
];

const ROLE_LEVEL_OPTIONS = [
  { id: "", tr: "Belirtmek istemiyorum", en: "Prefer not to say" },
  { id: "executive", tr: "Üst Yönetim / C-Level / Genel Müdür", en: "Executive / C-Level / General Manager" },
  { id: "director", tr: "Direktör / Fonksiyon Lideri", en: "Director / Functional Leader" },
  { id: "manager", tr: "Müdür", en: "Manager" },
  { id: "team_leader", tr: "Takım Lideri / Supervisor", en: "Team Leader / Supervisor" },
  { id: "specialist", tr: "Uzman / Bireysel Katkı Sağlayan", en: "Specialist / Individual Contributor" },
  { id: "operations", tr: "Operasyon / Saha Ekibi", en: "Operations / Frontline Team" },
  { id: "student", tr: "Öğrenci", en: "Student" },
  { id: "other", tr: "Diğer", en: "Other" }
];

export default function UserInfo({ onStart, language, setLanguage }) {
  const [firstNameOrAlias, setFirstNameOrAlias] = useState("");
  const [lastName, setLastName] = useState("");
  const [generationRange, setGenerationRange] = useState("");
  const [roleLevel, setRoleLevel] = useState("");
  const [kvkk, setKvkk] = useState(false);

  const isTR = language === "tr";

  const privacyText = isTR
    ? "Someren Labs, bu envanter kapsamında verdiğiniz yanıtları ve isteğe bağlı olarak paylaştığınız katılımcı bilgilerini; bireysel sonuç üretmek, şirket/takım bazlı toplu analiz yapmak, gelişim raporları oluşturmak ve kullanım/kota kaydını yönetmek amacıyla işler. Ad, soyad, takma ad, rol seviyesi ve jenerasyon aralığı alanları isteğe bağlıdır. Bu alanları boş bırakarak da envantere devam edebilirsiniz. Takma ad ile katılım, gerçek kimlik bilgisinin paylaşılmaması anlamına gelir; ancak sistemde erişim kodu, şirket/paket bilgisi ve kullanım kaydı teknik olarak tutulabilir."
    : "Someren Labs processes your inventory answers and any optional participant information you provide to generate individual results, produce aggregated company/team analysis, create development reports and manage access/quota records. Name, surname, alias, role level and generation range fields are optional. You may continue without filling these fields. Joining with an alias means you do not share your real identity information; however, access code, company/package information and usage records may still be technically stored in the system.";

  const consentText = isTR
    ? "Aydınlatma metnini okudum. Envanter yanıtlarımın ve isteğe bağlı paylaştığım bilgilerin bireysel sonuç, toplu şirket/takım analizi, gelişim raporu ve kullanım/kota takibi amacıyla işlenmesine açık rıza veriyorum."
    : "I have read the privacy notice. I give my explicit consent for my inventory answers and any optional participant information I provide to be processed for individual results, aggregated company/team analysis, development reporting and access/quota tracking.";

  function handleStart() {
    const fullName = [firstNameOrAlias, lastName].filter(Boolean).join(" ").trim();

    onStart({
      name: fullName,
      firstNameOrAlias,
      lastName,
      surname: lastName,
      generationRange,
      roleLevel,
      kvkk,
      kvkkConsent: kvkk,
      kvkkConsentAt: new Date().toISOString()
    });
  }

  return (
    <div className="ego-wrapper">
      <div
        className="ego-box"
        style={{
          maxWidth: 760,
          color: "#111827",
          background: "#ffffff"
        }}
      >
        <p
          style={{
            margin: "0 0 8px",
            letterSpacing: "0.12em",
            fontSize: 12,
            fontWeight: 800,
            color: "#92400e",
            textAlign: "center"
          }}
        >
          {isTR ? "KATILIMCI BİLGİLERİ" : "PARTICIPANT INFORMATION"}
        </p>

        <h2 style={{ textAlign: "center", color: "#111827", margin: "0 0 10px" }}>
          {isTR ? "KVKK ve İsteğe Bağlı Bilgiler" : "Privacy Notice and Optional Information"}
        </h2>

        <p style={{ textAlign: "center", color: "#374151", lineHeight: 1.5, margin: "0 0 18px" }}>
          {isTR
            ? "Aşağıdaki alanlar isteğe bağlıdır. Devam etmek için KVKK / açık rıza onayı gereklidir."
            : "The fields below are optional. Privacy / explicit consent approval is required to proceed."}
        </p>

        {/* 2026-08-14: Süre bilgisi burada da gösteriliyor. Hazır katılımcı linkiyle
            (?slAccessCode=...) gelen kişi erişim kodu ekranını ATLAR ve oradaki süre
            notunu hiç görmez. Metin AccessGuard'daki ile birebir aynı tutuldu. */}
        <p style={{ textAlign: "center", color: "#6b7280", fontSize: 13, margin: "-8px 0 18px" }}>
          {isTR
            ? "⏱ Yetişkinler bu envanteri genelde 6-7 dakikada tamamlar."
            : "⏱ Adults usually complete this inventory in about 6–7 minutes."}
        </p>

        <div style={{ marginBottom: 14 }}>
          <label style={styles.label}>Dil / Language:</label>
          <select
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            style={styles.input}
          >
            <option value="tr">Türkçe</option>
            <option value="en">English</option>
          </select>
        </div>

        <div style={styles.grid}>
          <label style={styles.label}>
            {isTR ? "Ad / Takma Ad (isteğe bağlı):" : "Name / Alias (optional):"}
            <input
              type="text"
              value={firstNameOrAlias}
              onChange={(e) => setFirstNameOrAlias(e.target.value)}
              style={styles.input}
              autoComplete="off"
            />
          </label>

          <label style={styles.label}>
            {isTR ? "Soyad (isteğe bağlı):" : "Surname (optional):"}
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              style={styles.input}
              autoComplete="off"
            />
          </label>

          <label style={styles.label}>
            {isTR ? "Jenerasyon / Doğum yılı aralığı (isteğe bağlı):" : "Generation / Birth-year range (optional):"}
            <select
              value={generationRange}
              onChange={(e) => setGenerationRange(e.target.value)}
              style={styles.input}
            >
              {GENERATION_OPTIONS.map((option) => (
                <option key={option.id || "empty"} value={option.id}>
                  {option[language]}
                </option>
              ))}
            </select>
          </label>

          <label style={styles.label}>
            {isTR ? "Rol seviyesi (isteğe bağlı):" : "Role level (optional):"}
            <select
              value={roleLevel}
              onChange={(e) => setRoleLevel(e.target.value)}
              style={styles.input}
            >
              {ROLE_LEVEL_OPTIONS.map((option) => (
                <option key={option.id || "empty"} value={option.id}>
                  {option[language]}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div style={styles.privacyBox}>
          <h3 style={styles.privacyTitle}>
            {isTR ? "Aydınlatma Metni" : "Privacy Notice"}
          </h3>

          <p style={styles.privacyText}>{privacyText}</p>

          <label style={styles.consentRow}>
            <input
              type="checkbox"
              checked={kvkk}
              onChange={() => setKvkk(!kvkk)}
              style={styles.checkbox}
            />
            <span>{consentText}</span>
          </label>
        </div>

        <button
          className="ego-btn accept"
          disabled={!kvkk}
          style={{
            marginTop: 16,
            width: "100%",
            opacity: kvkk ? 1 : 0.55,
            cursor: kvkk ? "pointer" : "not-allowed"
          }}
          onClick={handleStart}
        >
          {isTR ? "Envantere Başla" : "Start Inventory"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 12
  },
  label: {
    display: "grid",
    gap: 6,
    fontWeight: 800,
    color: "#111827",
    fontSize: 14
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: 6,
    padding: "11px 12px",
    borderRadius: 12,
    border: "1px solid #cbd5e1",
    color: "#111827",
    background: "#ffffff",
    minHeight: 44
  },
  privacyBox: {
    marginTop: 14,
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    background: "#f8fafc",
    padding: 14,
    color: "#111827"
  },
  privacyTitle: {
    margin: "0 0 8px",
    color: "#111827",
    fontSize: 16
  },
  privacyText: {
    margin: "0 0 12px",
    fontSize: 13,
    lineHeight: 1.5,
    color: "#334155"
  },
  consentRow: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    fontWeight: 800,
    color: "#111827",
    fontSize: 13,
    lineHeight: 1.45
  },
  checkbox: {
    width: 18,
    height: 18,
    marginTop: 2
  }
};
